import { get, post, put, del } from "../request";

/** 查询菜单列表（平铺） */
export function menuList() {
  return get("/education-system/menu/list");
}

/** 查询菜单下拉树 */
export function menuTreeSelect() {
  return get("/education-system/menu/treeselect");
}

/** 查询菜单详情 */
export function menuGet(menuId) {
  return get(`/education-system/menu/${menuId}`);
}

/** 新增菜单 */
export function menuAdd(data) {
  return post("/education-system/menu", data);
}

/** 修改菜单 */
export function menuUpdate(data) {
  return put("/education-system/menu", data);
}

/** 删除菜单 */
export function menuDelete(menuId) {
  return del(`/education-system/menu/${menuId}`);
}



// WEBPACK FOOTER //
// ./src/api/system/menu.js